export default __webpack_public_path__ + "static/media/falcon-wb.a0c798ea.svg";